import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';
import { _myInterestsList } from 'src/_mock/my-interests/my-interests';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class MyInterestsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async getInterestsList(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.myInterests.interestsList,
      params,
    };

    const options: HttpTypes.RequestOptions = {
      data: _myInterestsList,
      status: 200,
      delay: 2000,
    };

    const response = await this.api.fakeRequest(request, options);

    return httpResponseHandler(response);
  }

  async sendMyInterests(
    interestIds: string[],
    secondaryOnly?: boolean
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.myInterests.sendMyInterests,
      body: { interestIds },
      params: { secondaryOnly }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getMyInterests(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.myInterests.myInterestsResult,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getQuizQuestions(
    profileId?: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.myInterests.quizQuestions,
      params: { profileId }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async reorderPreferences(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.myInterests.reorderPreferences,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async maybeLater(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.myInterests.maybeLater,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
